// Elite custom start: isolated BYOB behavior; vendor 10.3 implementation remains separate. Elite custom end
if (!window.Eurus.loadedScript.has('elite-product-bundle.js')) {
window.Eurus.loadedScript.add('elite-product-bundle.js');

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.data('xEliteProductBundle', (
      sectionId,
      minimumItems,
      shopCurrency,
      discountType,
      discountValue,
      applyDiscountOncePerOrder
    ) => ({
      products: "",
      productsBundle: [],
      loading: false,
      addToCartButton: "",
      totalPrice: 0,
      errorMessage: false,
      totalDiscount: 0,
      amountPrice: 0,
      _isEliteByobBundle() {
        return sectionId.includes('homepage_build_your_box');
      },
      _getEliteByobMaxItems() {
        return 5;
      },
      _getEliteByobDiscountCode() {
        return 'BYOBUNDLE';
      },
      _getEliteByobTargetTotal() {
        return Math.round(6000 * Shopify.currency.rate);
      },
      _getBundleBagCount(productsBundle = this.productsBundle) {
        return productsBundle.reduce((total, item) => total + (Number(item.quantity) || 1), 0);
      },
      _showBundleWarning(message) {
        const warning = document.querySelector(`#bundler-sticky-${sectionId} .cart-warning`);
        if (warning) {
          warning.textContent = message;
          this.errorMessage = true;
          setTimeout(() => {
            this.errorMessage = false;
          }, 4000);
        }
      },
      initBundle(el) {
        this.addToCartButton = el.querySelector(".button-atc");
        this.handleProductsBundle();
        if (this._isEliteByobBundle()) {
          const slider = document.getElementById(`x-bundle-${sectionId}`);
          const stopAutoSlide = () => {
            const autoplay = slider?.splide?.Components?.Autoplay;
            if (autoplay) autoplay.pause();
          };
          ['touchstart', 'pointerdown', 'click'].forEach((eventName) => {
            slider?.addEventListener(eventName, stopAutoSlide, { once: true, passive: true });
          });
        }
        const saved = sessionStorage.getItem("bundle-" + sectionId);
        if (saved) {
          this.productsBundle = JSON.parse(saved);
          this.updateBundleContent(this.productsBundle);
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent(`eurus:product-bundle:productsCard-cached-${sectionId}`, {
              detail: {
                productsList: this.productsBundle
              }
            }));
          }, 500); 
        }
      },
      handleProductsBundle() {
        this.$watch('productsBundle', () => {
          document.dispatchEvent(new CustomEvent(`eurus:product-bundle:productsList-changed-${sectionId}`, {
            detail: {
              productsBundle: this.productsBundle
            }
          }));
          sessionStorage.setItem("bundle-" + sectionId, JSON.stringify(this.productsBundle));
        });
      },
      _getSelectedValueId(el) {
        return el.querySelector("select option[selected][value], fieldset input:checked")?.dataset.optionValueId;
      },
      _getCurrentVariantEl(el) {
        return el.querySelector(`script[type="application/json"][data-option-value-id='${this._getSelectedValueId(el)}']`);
      },
      _getCurrentVariable(el) {
        return JSON.parse(this._getCurrentVariantEl(el)?.textContent);
      },
      addToBundle(el, productId, productUrl, hasVariant, name_edt, productOnlyAddedOnce, itemQuantity = 1) {
        let productsBundle = JSON.parse(JSON.stringify(this.productsBundle))
        itemQuantity = Math.max(1, Math.min(Number(itemQuantity) || 1, this._getEliteByobMaxItems()));
        if (this._isEliteByobBundle() && this._getBundleBagCount(productsBundle) + itemQuantity > this._getEliteByobMaxItems()) {
          this._showBundleWarning('Your coffee box can include up to 5 bags.');
          return;
        }
        // Elite custom start: preserve spaces across stacked product-title line breaks.
        const productName = el.closest(".x-product-bundle-data").querySelector(".product-name").innerText.replace(/\s+/g, " ").trim();
        // Elite custom end
        const currentVariant = hasVariant ? this._getCurrentVariable(el.closest(".x-product-bundle-data")) : JSON.parse(el.closest(".x-product-bundle-data").querySelector(`script[type='application/json'][data-id='${productId}']`).textContent);
        const price = !hasVariant && JSON.parse(el.closest(".x-product-bundle-data").querySelector(".current-price")?.textContent);
        const featured_image = currentVariant.featured_image ? currentVariant.featured_image.src : el.closest(".x-product-bundle-data").querySelector(".featured-image").textContent;
        const edtElement = el.closest(".x-product-bundle-data").querySelector(`.hidden.cart-edt-properties-${productId}`);
        let shippingMessage = '';
        if(edtElement){
          shippingMessage = edtElement.value.replace("time_to_cut_off", Alpine.store('xEstimateDelivery').noti);
        }
        const preorderElement = el.closest(".x-product-bundle-data").querySelector('.hidden.preorder-edt-properties');
        let preorderMessage = '';
        if(preorderElement){
          preorderMessage = preorderElement.value;
        }
        
        const properties = {
          ...(name_edt && shippingMessage && { [name_edt]: shippingMessage }),
          ...(preorderMessage && { Preorder: preorderMessage }),
        };

        let variantId = hasVariant ? currentVariant : currentVariant.id; 
        let newProductsBundle = [];
        let newItem = hasVariant ? { ...currentVariant, title: currentVariant.title.replaceAll("\\",""), product_id: productId, product_name: productName, productUrl: `${productUrl}?variant=${currentVariant.id}`, featured_image: featured_image, quantity: itemQuantity, "properties": properties} : { id: variantId, product_id: productId, product_name: productName, productUrl: productUrl, featured_image: featured_image, quantity: itemQuantity, price: price, "properties": properties }
        
        if (this._isEliteByobBundle()) {
          const existingItemIndex = productsBundle.findIndex((item) => item.id === newItem.id);
          if (existingItemIndex !== -1) {
            newProductsBundle = productsBundle.map((item, index) => {
              if (index !== existingItemIndex) return item;
              return { ...item, quantity: (Number(item.quantity) || 1) + itemQuantity };
            });
          } else {
            newProductsBundle = [...productsBundle, newItem];
          }
        } else {
          newProductsBundle = [...productsBundle , newItem];
        }
        this.productsBundle = newProductsBundle;
        this.errorMessage = false;
        this.updateBundleContent(newProductsBundle)
        let bundleContentContainer = document.getElementById(`bundle-content-container-${sectionId}`);
        requestAnimationFrame(() => {
          let splide = bundleContentContainer.splide;
          if (splide) {
            splide.refresh();
            let lastIndex = splide.Components.Controller.getEnd();
            splide.go(lastIndex);
          }
        });
      },
      async handleAddToCart(el) {
        this.loading = true;
        await Alpine.store('xCartHelper').waitForCartUpdate();
        window.updatingCart = true;

        setTimeout(() => { 
          let items = JSON.parse(JSON.stringify(this.productsBundle));
          const applyEliteByobDiscount = this._isEliteByobBundle() && this._getBundleBagCount(items) === this._getEliteByobMaxItems();
          items = items.reduce((data, product) => {
            data[product.id] ? data[product.id].quantity += product.quantity : data[product.id] = product;
            return data;
          }, {});
          
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body:  JSON.stringify({ "items": items, "sections":  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id) })
          }).then((response) => {
            return response.json();
          }).then((response) => {

            document.dispatchEvent(new CustomEvent(`eurus:product-bundle:products-changed-${sectionId}`, {
              detail: {
                productsBundle: Object.values(items),
                el: el.closest(".product-bundler-wrapper")
              }
            }));

            if (response.status == '422') {
              const errorMessage = el.closest('.bundler-sticky').querySelector('.cart-warning');

              this.errorMessage = true;
              if (errorMessage) {
                errorMessage.textContent = response.description;
              }
              return;
            }
            this.errorMessage = false;
            const finishCartUpdate = (cartResponse) => {
              Alpine.store('xCartHelper').reRenderSections(cartResponse.sections);
              if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                Alpine.store('xQuickView').show = false;
              }
              Alpine.store('xPopup').close();
              if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
                Alpine.store('xCartNoti').setItem(cartResponse); 
              } else {
                Alpine.store('xMiniCart').openCart();
                document.dispatchEvent(new CustomEvent("eurus:cart:redirect"));
              }
              Alpine.store('xCartHelper').currentItemCount = parseInt(document.getElementById('cart-icon-bubble').innerHTML);
              document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
            };

            if (applyEliteByobDiscount) {
              fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  discount: this._getEliteByobDiscountCode(),
                  sections: Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
                })
              }).then((discountResponse) => {
                return discountResponse.json();
              }).then((discountResponse) => {
                document.cookie = `eurus_discount_code=${this._getEliteByobDiscountCode()}; path=/`;
                if (Alpine.store('xCouponCodeDetail')) {
                  Alpine.store('xCouponCodeDetail').appliedDiscountCodes = [this._getEliteByobDiscountCode()];
                }
                finishCartUpdate(discountResponse);
              }).catch(() => {
                finishCartUpdate(response);
              });
            } else {
              finishCartUpdate(response);
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          }).finally(() => {
            window.updatingCart = false;
            this.loading = false;
            this.productsBundle = [];
            this.totalPrice = 0;
            this.addToCartButton.setAttribute('disabled', 'disabled');
          })
        }, 0)
      },
      clearBundle() {
        this.productsBundle = [];
        this.totalPrice = 0;
        this.totalDiscount = 0;
        this.amountPrice = 0;
        this.errorMessage = false;
        this.addToCartButton?.setAttribute('disabled', 'disabled');
        sessionStorage.removeItem("bundle-" + sectionId);
        document.dispatchEvent(new CustomEvent(`eurus:product-bundle:productsList-changed-${sectionId}`, {
          detail: {
            productsBundle: this.productsBundle
          }
        }));
        document.dispatchEvent(new CustomEvent(`eurus:product-bundle:reset-${sectionId}`));
      },
      updateBundleItemQuantity(indexItem, delta) {
        let productsBundle = JSON.parse(JSON.stringify(this.productsBundle));
        const item = productsBundle[indexItem];
        if (!item) return;

        const currentQuantity = Number(item.quantity) || 1;
        const nextQuantity = currentQuantity + delta;
        if (nextQuantity < 1) return;

        if (this._isEliteByobBundle() && delta > 0 && this._getBundleBagCount(productsBundle) >= this._getEliteByobMaxItems()) {
          this._showBundleWarning('Your coffee box can include up to 5 bags.');
          return;
        }

        productsBundle[indexItem] = { ...item, quantity: nextQuantity };
        this.productsBundle = productsBundle;
        this.errorMessage = false;
        this.updateBundleContent(productsBundle);
      },
      updateBundleContent(productsBundle) {
        const bagCount = this._getBundleBagCount(productsBundle);
        let total = productsBundle.map(item => item.price * (Number(item.quantity) || 1)).reduce((total, item) => total + item, 0);
        
        if (bagCount >= minimumItems) {
          this.addToCartButton.removeAttribute('disabled');
          let discount = 0;
          let totalDiscount = 0;

          if (this._isEliteByobBundle() && bagCount === this._getEliteByobMaxItems() && total > this._getEliteByobTargetTotal()) {
            totalDiscount = this._getEliteByobTargetTotal();
            let amount = total - totalDiscount;
            this.amountPrice = Alpine.store('xHelper').formatMoney(amount, shopCurrency);
            this.totalDiscount = Alpine.store('xHelper').formatMoney(totalDiscount, shopCurrency);
          } else if (!Number.isNaN(discountValue)) {
            discount = Number(discountValue);

            if (discountType == 'percentage' && Number.isInteger(discount) && discount > 0 && discount < 100) {
              totalDiscount = Math.ceil(total - total * discount / 100);
            }

            if (discountType == 'amount' && discount > 0) {
              discount = (Number.parseFloat(discountValue)).toFixed(2);
              if (applyDiscountOncePerOrder) {
                totalDiscount = total - discount * Shopify.currency.rate * 100;
              } else {
                totalDiscount = total - bagCount * discount * Shopify.currency.rate * 100;
              }
            }

            if (totalDiscount > 0) {
              let amount = total - totalDiscount;
              this.amountPrice = Alpine.store('xHelper').formatMoney(amount, shopCurrency);
              this.totalDiscount = Alpine.store('xHelper').formatMoney(totalDiscount, shopCurrency);
            } else {
              this.amountPrice = Alpine.store('xHelper').formatMoney(0, shopCurrency);
              this.totalDiscount = 0;
            }
          } else {
            this.amountPrice = 0;
            this.totalDiscount = 0;
          }
        } else {
          this.totalDiscount = 0;
          this.addToCartButton.setAttribute('disabled', 'disabled');
        }
        this.totalPrice = Alpine.store('xHelper').formatMoney(total, shopCurrency);
      },
      removeBundle(el, indexItem) {
        let item = this.productsBundle[indexItem]
        let newProductsBundle = this.productsBundle.filter((item, index) => index != indexItem)
        this.productsBundle = newProductsBundle;
        this.updateBundleContent(newProductsBundle);
        let bundleContentContainer = document.getElementById(`bundle-content-container-${sectionId}`);
        requestAnimationFrame(() => {
          let splide = bundleContentContainer.splide;
          if (splide) {
            splide.refresh();
            let lastIndex = splide.Components.Controller.getEnd();
            splide.go(lastIndex);
          }
        });

        document.dispatchEvent(new CustomEvent(`eurus:product-bundle:remove-item-${sectionId}`, {
          detail: {
            item: item,
            el: el
          }
        }));
      },
      displayDiscountValueLabel () {
        let discount = 0;
        if (!Number.isNaN(discountValue)) {
          discount = Number(discountValue);
          if (discount > 0) {
            discount = (Number.parseFloat(discountValue)).toFixed(2) * Shopify.currency.rate * 100;
          }
          return Alpine.store('xHelper').formatMoney(discount, shopCurrency);
        }
      }
    }));

    Alpine.data('xEliteProductItemBundle', (
      sectionId,
      addToBundle,
      unavailableText,
      soldoutText,
      addedText,
      handleSectionId,
      productUrl,
      productId,
      hasVariant,
      productOnlyAddedOnce
    ) => ({
      productsList: [],
      dataVariant: [],
      currentVariant: '',
      isSelect: false,
      bundleQuantity: 1,
      productId: productId,
      productUrl: productUrl,
      initEvent() {
        if (hasVariant) {
          document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}:${productUrl}`, (e) => {
            this.currentVariant = e.detail.currentVariant,
            this.renderAddToBundleButton();
            this.checkVariantSelected();
            this.handleEliteByobAutoAdd();
            if (this.currentVariant && this.currentVariant.id) {
              this.productUrl = productUrl + `/?variant=${this.currentVariant.id}`
            }
          });
          document.addEventListener(`eurus:card-product-bundle:productsList-changed-${handleSectionId}`, (e) => {
            this.productsList = e.detail.productsList;
            this.renderAddToBundleButton();
          });
        } else {
          document.addEventListener(`eurus:product-bundle:productsCard-cached-${handleSectionId}`, (e) => {
            const buttonATB = document.getElementById('x-atc-button-' + sectionId);
            if (!buttonATB) return;
            const item = e.detail.productsList.find(({ product_id }) => product_id === this.productId);
            if (item) {
              buttonATB.setAttribute('disabled', 'disabled');
            }
          });
        }

        document.addEventListener(`eurus:product-bundle:products-changed-${handleSectionId}`, (e) => {
          e.detail.productsBundle.map(item => {
            if(hasVariant && item.product_id == this.productId && this.currentVariant.available) {
              let buttonATC = document.getElementById('x-atc-button-' + sectionId);
              if (buttonATC) buttonATC.removeAttribute('disabled');
            } else if(item.product_id == this.productId) {
              let buttonATC = document.getElementById('x-atc-button-' + sectionId);
              if (buttonATC) buttonATC.removeAttribute('disabled');
            }
          })
          if(productOnlyAddedOnce) {
            this.setUnSelectVariant();
          }
        })

        document.addEventListener(`eurus:product-bundle:remove-item-${handleSectionId}`, (e) => {
          if (this.isSelect && e.detail.item.product_id == this.productId && hasVariant) {
            if (this.currentVariant && this.currentVariant.available) {
              let buttonATC = document.getElementById('x-atc-button-' + sectionId);
              if (buttonATC) {
                buttonATC.removeAttribute('disabled');
                const addButtonText = buttonATC.querySelector('.x-atc-text');
                if (addButtonText) addButtonText.textContent = addToBundle
              }
            }
            this.setUnSelectVariant(e.detail.item);
          } else if(e.detail.item.product_id == this.productId) { 
            let buttonATC = document.getElementById('x-atc-button-' + sectionId);
            if (buttonATC) {
              buttonATC.removeAttribute('disabled');
              const addButtonText = buttonATC.querySelector('.x-atc-text');
              if (addButtonText) addButtonText.textContent = addToBundle;
            }

            if(productOnlyAddedOnce) {
              const cardProducts = document.getElementById('bundle-product-' + e.detail.item.product_id);
              cardProducts?.classList.remove("cursor-pointer", "pointer-events-none", "opacity-70")
            }
          }
        })

        document.addEventListener(`eurus:product-bundle:reset-${handleSectionId}`, () => {
          let buttonATC = document.getElementById('x-atc-button-' + sectionId);
          if (buttonATC) {
            const addButtonText = buttonATC.querySelector('.x-atc-text');
            if (hasVariant) {
              if (this.currentVariant && this.currentVariant.available) {
                buttonATC.removeAttribute('disabled');
              }
              if (addButtonText) addButtonText.textContent = addToBundle;
            } else {
              buttonATC.removeAttribute('disabled');
              if (addButtonText) addButtonText.textContent = addToBundle;
            }
          }

          if(productOnlyAddedOnce) {
            this.setUnSelectVariant();
            const cardProducts = document.getElementById('bundle-product-' + this.productId);
            cardProducts?.classList.remove("cursor-pointer", "pointer-events-none", "opacity-70");
          }
        })
      },
      setVariantSelected(el) {
        if (this.currentVariant && this.dataVariant.findIndex(item => (item.id == this.currentVariant.id && item.disable)) != -1) {
          let buttonATB = el.closest('.bundle-product').querySelector('.x-atb-button');
          buttonATB.setAttribute('disabled', 'disabled');
        }
      },
      setDisableSelectProduct(el) {
        if (productOnlyAddedOnce) {
          let newVariants = JSON.parse(JSON.stringify(this.dataVariant)).map(item => (item.id == this.currentVariant.id) ? { id: item.id, disable: true } : { id: item.id, disable: item.disable})
          this.dataVariant = newVariants;
          let buttonATB = el.closest('.bundle-product').querySelector('.x-atb-button');
          buttonATB.setAttribute('disabled', 'disabled');
          const addButtonText = buttonATB.querySelector('.x-atc-text');
          if (addButtonText) addButtonText.textContent = addedText;
        }
      },
      handleEliteByobAutoAdd() {
        if (!handleSectionId.includes('homepage_build_your_box') || !productOnlyAddedOnce || !hasVariant) return;
        if (!this.isSelect || !this.currentVariant || !this.currentVariant.id || !this.currentVariant.available) return;
        if (this.productsList.find(({ id }) => id === this.currentVariant.id)) return;

        const buttonATB = document.getElementById('x-atc-button-' + sectionId);
        if (!buttonATB || buttonATB.disabled) return;

        const addButtonText = buttonATB.querySelector('.x-atc-text');
        if (addButtonText && addButtonText.textContent.trim() === addedText) return;

        setTimeout(() => {
          if (!buttonATB.disabled) {
            buttonATB.click();
            const addButtonText = buttonATB.querySelector('.x-atc-text');
            if (addButtonText) addButtonText.textContent = addedText;
          }
        }, 0);
      },
      setUnSelectVariant(product) {
        let newVariants = "";
        if (product) {
          newVariants = JSON.parse(JSON.stringify(this.dataVariant)).map(item => (item.id == product.id) ? { id: item.id, disable: false } : { id: item.id, disable: item.disable})
        } else {
          newVariants = JSON.parse(JSON.stringify(this.dataVariant)).map(item => ({ id: item.id, disable: false }))
        }
        this.dataVariant = newVariants;
      },
      renderAddToBundleButton() {
        const buttonATB = document.getElementById('x-atc-button-' + sectionId)

        if (!buttonATB) return;

        const addButtonText = buttonATB.querySelector('.x-atc-text');

        if (addButtonText) {
          if (this.currentVariant) {
            const itemVariant = this.productsList.find(({ id }) => id === this.currentVariant.id);
            if (itemVariant && buttonATB) {
              setTimeout(() => {
                buttonATB.setAttribute('disabled', 'disabled');
                if (this.currentVariant.available) {
                  addButtonText.textContent = addedText;
                } else {
                  addButtonText.textContent = soldoutText;
                }
                return;
              }, 100);
            }
            if (this.currentVariant.available) {
              buttonATB.removeAttribute('disabled');
              addButtonText.textContent = addToBundle;
            } else {
              addButtonText.textContent = soldoutText;
            }
          } else {
            addButtonText.textContent = handleSectionId.includes('homepage_build_your_box') ? addToBundle : unavailableText;
          }
        }
      },
      checkVariantSelected() {
        const fieldset = [...document.querySelectorAll(`#variant-update-${sectionId} fieldset`)];
        if(fieldset.findIndex(item => !item.querySelector("input:checked")) == "-1") {
          this.isSelect = true;
        }
      }
    }));

    Alpine.data('xEliteProductList', (
      handleSectionId
    ) => ({
      productsList: [],
      init() {
        document.addEventListener(`eurus:product-bundle:productsList-changed-${handleSectionId}`, (e) => {
          this.productsList = e.detail.productsBundle;
          document.dispatchEvent(new CustomEvent(`eurus:card-product-bundle:productsList-changed-${handleSectionId}`, {
            detail: {
              productsList: this.productsList
            }
          }));
        })
      }
    }))
  });
});
}
